import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatProjects = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => {
        const displayName = item.name || item.projectName || "Proyecto sin nombre";
        let phases = item.phases;

        if (typeof phases === "string") {
            phases = phases
                .split(",")
                .map((p) => p.trim())
                .filter(Boolean);
        } else if (!Array.isArray(phases)) {
            phases = [];
        }

        let documentation = item.documentation;
        if (!Array.isArray(documentation)) {
            documentation = [];
        }

        return {
            ...item,
            phases,
            documentation,
            // normalizamos para que el resto de la app pueda usar siempre name/label
            name: displayName,
            label: displayName,
            value: item._id,
            endDate: item.endDate && moment(item.endDate),
            startDate: item.startDate && moment(item.startDate),
        };
    };

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchProjects,
    create: createProject,
    update: updateProject,
    delete: deleteProjects
} = createCrudActions('PROJECT', "Projecto", formatProjects);
